var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pdf_loader"},[(_vm.iframeSignedUrl)?_c('div',{staticClass:"pdf",staticStyle:{"height":"90vh"}},[_c('iframe',{staticStyle:{"border":"0px"},attrs:{"src":_vm.iframeSignedUrl,"height":"100%","width":"100%"}})]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }